import { collection, deleteDoc, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const businessThemesCol = (businessId) => collection(db, "businesses", businessId, "themes");
const businessThemeDoc = (businessId, themeId) => doc(db, "businesses", businessId, "themes", themeId);

/** Default theme styles applied to every new form when no theme is selected. */
export const getDefaultTheme = () => ({
    themeName: "",
    useCustomStyles: true,
    logo: "",
    backgroundImage: "",
    logoUrl: "",
    backgroundImageUrl: "",
    backgroundColor: "#ffffff",
    headingColor: "#1a1a1a",
    instructionsColor: "#6b7280",
    inputTextColor: "#1f2937",
    cardBackgroundColor: "#ffffff",
    cardTextColor: "#1f2937",
    cardBorderColor: "#e5e7eb",
    cardHoverBorderColor: "#348C9E",
    buttonColor: "#348C9E",
    buttonTextColor: "#ffffff",
    buttonHoverColor: "#2d7a8a",
    textColor: "#1a1a1a",
    accentColor: "#348C9E",
    fontFamily: "Arial, sans-serif",
    headerFontSize: "2.25rem",
    headerFontWeight: "700",
    instructionsFontSize: "1.125rem",
    inputBackground: "#ffffff",
    inputBorderColor: "#e5e7eb",
    inputFocusBorderColor: "#348C9E",
    inputHoverBorderColor: "#d1d5db",
    progressBarColor: "#348C9E",
    progressBarBackground: "rgba(0, 0, 0, 0.06)",
    progressIndicatorActiveColor: "#348C9E",
    progressIndicatorInactiveColor: "#e9ecef",
    progressIndicatorTextColor: "#ffffff",
    progressIndicatorInactiveTextColor: "#6c757d",
    progressIndicatorConnectorColor: "#e9ecef",
    formBorderRadius: "24px",
    cardBorderRadius: "16px",
    inputBorderRadius: "12px",
    buttonBorderRadius: "12px",
    cardShadowIntensity: "0.08",
    inputShadowIntensity: "0.05",
    buttonShadowIntensity: "0.1",
    bannerBackground: "#fef3c7",
    bannerTextColor: "#92400e",
    wrapperOpacity: 1,
});

export const listThemes = async (businessId) => {
    const snap = await getDocs(businessThemesCol(businessId));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const deleteTheme = async (businessId, themeId) => {
    await deleteDoc(businessThemeDoc(businessId, themeId));
};

export const getThemeById = async (businessId, themeId) => {
    const snap = await getDoc(businessThemeDoc(businessId, themeId));
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};


